import React from "react";

const ChatMessage = ({ message }) => {
    const isUser = message.sender === "user";

    return (
        <div
            style={{
                display: "flex",
                justifyContent: isUser ? "flex-end" : "flex-start",
                marginBottom: "20px",
            }}
        >
            <div
                style={{
                    maxWidth: "75%",
                    padding: "15px",
                    borderRadius: "12px",
                    backgroundColor: isUser ? "#007bff" : "#f1f1f1",
                    color: isUser ? "#fff" : "#000",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                }}
            >
                <div
                    style={{
                        fontWeight: "bold",
                        marginBottom: "8px",
                    }}
                >
                    {isUser ? "👤 You" : "🤖 AI Assistant"}
                </div>

                <div>{message.text}</div>

                {/* Display Sources */}
                {!isUser &&
                    message.sources &&
                    message.sources.length > 0 && (
                        <div
                            style={{
                                marginTop: "15px",
                                borderTop: "1px solid #ccc",
                                paddingTop: "10px",
                            }}
                        >
                            <strong>Sources</strong>

                            <ul
                                style={{
                                    marginTop: "8px",
                                    paddingLeft: "20px",
                                }}
                            >
                                {message.sources.map((source, index) => (
                                    <li key={index}>
                                        📄 {source.filename}

                                        {source.page && (
                                            <>
                                                {" "}
                                                (Page {source.page})
                                            </>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                {/* Timestamp */}
                {message.time && (
                    <div
                        style={{
                            marginTop: "10px",
                            fontSize: "12px",
                            opacity: 0.7,
                            textAlign: "right",
                        }}
                    >
                        {message.time}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ChatMessage;